module.exports = __webpack_public_path__ + "img/photo15.74cb5415.jpg";